import React from 'react'

export function TableHeadComponent({ children }) {
  return (
    <thead className="xd-table-thead">
      <tr  className="xd-table-row xd-table-th">{children}</tr>
    </thead>
  )
}
